import {createBrowserRouter} from "react-router-dom";

import PathConstants from "./pathConstants";
import Login from "../pages/login/Login";
import AppLayout from "../pages/layout/AppLayout";
import ConstructionCalculationsNote from "../pages/constructionCalculationsNote/ConstructionCalculationsNote";
import PageNotFound from "../pages/notFound/PageNotFound";
import ConstructionNew from "../pages/constructionNew/ConstructionNew";
import ConstructionsNew from "../pages/constructionsNew/ConstructionsNew";
import ConstructionCalculationsNew from "../pages/constructionCalculationsNew/ConstructionCalculationsNew";

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        index: true,
        path: PathConstants.Home,
        element: <ConstructionsNew />,
      },
      {
        index: true,
        path: `${PathConstants.Constructions}/:id`,
        element: <ConstructionNew />,
      },
      {
        index: true,
        path: `${PathConstants.Constructions}/:id/${PathConstants.Calculations}/:calculationId`,
        element: <ConstructionCalculationsNew />,
      },
      {
        index: true,
        path: `${PathConstants.Constructions}/:id/${PathConstants.Calculations}/:calculationId/${PathConstants.CalculationsNote}`,
        element: <ConstructionCalculationsNote />,
      },
    ],
  },
  {path: PathConstants.Login, element: <Login />},
  {path: "*", element: <PageNotFound />},
]);

export default router;
